export interface AdditionalSubTitle {
  icon: string;
  content: string | number;
}
